import { ReactNode } from 'react'
import { Navbar } from './Navbar'
import { MenuVariantBanner } from './MenuVariantBanner'

interface WorkspaceLayoutProps {
  children: ReactNode
}

/**
 * Layout for workspace-style pages (wizard, focused tasks).
 * Unlike MainLayout, content has no padding or max-width constraints.
 * Children control their own layout (e.g., sidebar + content).
 */
export function WorkspaceLayout({ children }: WorkspaceLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <MenuVariantBanner />

      {/* Full-width content area */}
      <main className="flex-1 flex flex-col overflow-hidden">
        {children}
      </main>
    </div>
  )
}
